import {
  apiToEvervizChartProps,
  EvervizChart,
} from "~/components/EvervizChart";
import {
  isDatavizBlockContentBlock,
  isPlainContentBlockContentBlock,
  isYoutubeEmbedBlock,
} from "~/components/PostContentBlocks/content-block-type-guards";
import { PostContentBlock } from "~/types/asgard/PostContentBlock";
import { ArticleContentBlock } from "~/components/ArticleContentBlock";
import { YouTubeEmbedBlock } from "~/components/YouTubeEmbedBlock/YouTubeEmbedBlock";

export type ReportPreviewContentBlockProps = {
  postContentBlocks: PostContentBlock[];
};

export const ReportPreviewContentBlock = ({
  contentBlock,
}: {
  contentBlock: PostContentBlock;
}) => {
  if (isDatavizBlockContentBlock(contentBlock)) {
    return <EvervizChart {...apiToEvervizChartProps(contentBlock)} />;
  }

  if (isPlainContentBlockContentBlock(contentBlock)) {
    return (
      <div className="text-body-large leading-body">
        <ArticleContentBlock contentHTML={contentBlock.plain_content} />
      </div>
    );
  }

  if (isYoutubeEmbedBlock(contentBlock)) {
    return (
      <YouTubeEmbedBlock
        src={contentBlock.video_url}
        title="YouTube video player"
      />
    );
  }
  return null;
};
